import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TiposEquipamientoLaboratorioService } from "./tipos-equipamiento-laboratorio.service";
import { entityTipoEquipamientoLaboratorioLoadFailure, entityTipoEquipamientoLaboratorioLoadRequest, entityTipoEquipamientoLaboratorioLoadSuccess } from "./tipos-equipamiento-laboratorio.actions";
import { catchError, map, mergeMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class TipoEquipamientoEffect {
  loadRequestTipoEquipamiento = createEffect(() => {
    return this.actions$.pipe(
      ofType(entityTipoEquipamientoLaboratorioLoadRequest),
      mergeMap(() =>
        this.tipoEquipamientoService.getTipoEquipamientoLaboratorio().pipe(
          map((items) => entityTipoEquipamientoLaboratorioLoadSuccess({ items })),
          catchError((error) => of(entityTipoEquipamientoLaboratorioLoadFailure({ error })))
        )
      )
    )
  })

  constructor(
    private actions$: Actions,
    private tipoEquipamientoService: TiposEquipamientoLaboratorioService
  ) { }
}
